import { CommonModule } from '@angular/common';

import { AsDocumentManagementRoutingModule } from './document-management-routing.module';
import { DocumentManagementComponent } from './document-management.component';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from 'src/app/shared/shared.module';
/* import { UpdateAsEnterpriseComponent } from './update-as-enterprise/update-as-enterprise.component'; */
/* import { AddAsEnterpriseComponent } from './add-as-enterprise/add-as-enterprise.component'; */
/* import { ViewAsEnterpriseComponent } from './view-as-enterprise/view-as-enterprise.component'; */
import { MaterialModule } from 'src/app/core/material';

import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ListDocumentTemplateModule } from './list-document-template/list-document-template.module';
import { DocumentTemplateFormModule } from './document-template-form/document-template-form.module';
import { DialogPreviewPdfComponent } from './dialog-preview-pdf/dialog-preview-pdf.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
} from '@angular/material';
import { SearchDocumentTemplateComponent } from './search-document-template/search-document-template.component';

@NgModule({
  declarations: [DocumentManagementComponent, DialogPreviewPdfComponent, SearchDocumentTemplateComponent],
  imports: [
    CommonModule,
    AsDocumentManagementRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MaterialModule,
    MatSortModule,
    MatTableModule,
    HttpClientModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    ListDocumentTemplateModule,
    DocumentTemplateFormModule,
    NgxExtendedPdfViewerModule
  ],
  exports: [
    CdkTableModule,
    CdkTreeModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatButtonModule,
    DialogPreviewPdfComponent,
    DocumentManagementComponent
  ],
  entryComponents:
  [
    /* AddAsEnterpriseComponent,
    UpdateAsEnterpriseComponent,
    ViewAsEnterpriseComponent */
    DialogPreviewPdfComponent,
    SearchDocumentTemplateComponent
  ]
})
export class DocumentManagementModule { }
